import { ApiLoader, useApiResource } from './apiHelpers';

export interface UnlayerUser {
  id: string;
  signature: string;
}

const loadUnlayerUser: ApiLoader<UnlayerUser | null> = async authFetch => {
  const result: Partial<UnlayerUser> | null = await authFetch('/communication/unlayer/user');
  return result?.id && result.signature ? { id: result.id, signature: result.signature } : null;
};

export const useUnlayerUserSignature = () => {
  const { data, loading, error } = useApiResource(loadUnlayerUser, null, "Erreur lors de l'authentification Unlayer");
  return { user: data, loading, error: error || null };
};
